<template>
    <v-container id="docForm" class="max-width">
        <!-- first card -->
        <v-card>
            <v-toolbar dense flat color="secondary">
                <v-toolbar-title>Add Existing Devices IMEI</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>


            <v-card-text>
                <v-row class="subtitle-2 text--primary">

                    <!-- <v-col cols="12" md="4">
                        <span>Total Imeis: {{ imeiRetailsRecord.totalInvoiceImeis }}</span>
                        <br />

                        <span>Imeis Added: {{ imeiRetailsRecord.totalImeisAdded }}</span>
                        <br />
                        <div>Remaining Imeis: <span style="color: red">{{ imeiRetailsRecord.remainingImeis }}</span>
                        </div>
                    </v-col> -->

                </v-row>

                <v-row>
                    <v-col cols="12" md="8">

                        <v-autocomplete style="width: 500px" autocomplete="off" v-model="select" :items="products"
                            :search-input.sync="searchProducts" @change="setImeiItem(select)" item-text="Name"
                            item-value="id" cache-items class="mt-2" flat label="Search Product" outlined dense>
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-btn class="float-right" color="primary" text @click.native="fetchImeis" :loading="loader">
                            View Already Added Imeis <v-icon right dark>mdi-eye</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <span class="style-16">{{ productName }}</span>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!-- end of first card -->

        <v-card class="mt-4">
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field label="Imei Number" @keyup.enter="addImei" outlined dense
                            v-model="imeiNumber"></v-text-field>
                    </v-col>

                    <v-col cols="3">
                        <v-btn color="primary" @click="saveImei" :loading="loader">SAVE IMEI</v-btn>
                    </v-col>

                    <v-col cols="3">
                        <span style="color: red; font-size: 20px">Counter: {{ newImeis.length }}</span>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- no bp card -->
        <v-card class="mt-4">
            <v-card-text>
                <v-row dense class="subtitle-2 text--primary">
                    <v-col cols="8">
                        <v-data-table light dense :items-per-page="1000" :headers="headers" :items="newImeis"
                            :mobile-breakpoint="0">

                            <!-- action template -->
                            <template v-slot:item.delete="{ item }">
                                <v-btn @click="deleteImei(item)" color="red" icon>
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <!-- end -->
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!-- end of card -->

        <!-- product quick add dialog -->
        <v-dialog v-model="imeiDialog" max-width="650px">
            <v-card>
                <v-toolbar dense color="primary" dark>
                    <v-toolbar-title>IMEI LIST</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="imeiDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-container>
                        <v-row justify="center">
                            <v-col cols="12">
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                                    hide-details></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-data-table light dense :items-per-page="100" :headers="imeiHeaders"
                                    :items="imeiRecords" item-key="id" :mobile-breakpoint="0" :search="search">
                                    <template v-slot:item.status="{ item }">
                                        <span v-if="item.soldStatus == 1" style="color: red; font-weight: bold;">
                                            Sold
                                        </span>
                                        <span v-if="item.soldStatus != 1" style="color: green; font-weight: bold;">
                                            In Stock
                                        </span>
                                    </template>

                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- end of modal-->


        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
export default {
    props: {
        docTitle: {
            type: String
        },
        backUrl: {
            type: String
        },
        noTitle: {
            type: String
        },
    },
    computed: {
        activeStore() {
            return localStorage.getItem("store_id");
        },
    },
    data: () => ({
        select: "",
        imeiDialog: false,
        search: "",
        imeiHeaders: [
            { text: "Product", value: "product.Name" },
            { text: "Imei", value: "imei" },
            { text: "Status", value: "status" }
        ],
        imeiNumber: "",
        newImeis: [],
        record: {},
        productName: "",
        selectedProductId: null,
        searchProducts: null,
        products: [],
        productId: null,
        imeiRetailsRecord: {},
        editingDialog: false,
        editItem: {},
        DocNum: null,
        loader: false,
        copyObj: null,
        invoiceData: {},
        imeiRecords: [],
        copyData: [{ Name: "Goods Receipt", id: 12 }],
        orderItems: [],
        accounts: [],
        pageItems: 100,
        headers: [
            { text: "Product", value: "productName" },
            { text: "IMEI", value: "imei" },
            { text: "Action", value: "delete" },
        ],
        paymentHeaders: [
            { text: "Account", value: "Name" },
            { text: "Amount", value: "SumApplied" },
            { text: "Ref/Code", value: "PaymentRemarks" }
        ]
    }),
    watch: {
        searchProducts(val) {
            if (val && val !== this.select && this.querySelections(val)) {
                this.querySelections(val);
            }
        },
    },
    methods: {
        setImeiItem(id) {
            var product = this.products.find(record => {
                return record.id === id;
            });

            this.selectedProductId = id;
            this.productName = product.Name;
            this.select = null;
            this.products = [];
        },
        querySelections(searchText) {
            const self = this;
            const url = "/products/search";

            const data = {
                SearchText: searchText.toString(),
                // CustomerId: customerId
            };

            this.$store
                .dispatch("post", { url, data })
                .then(res => {
                    if (res.ResultCode == 1200) {
                        if (res.ResponseData != null) {
                            self.products = res.ResponseData;
                        }
                    } else {
                        self.$store.commit("btnLoader", false);
                        // this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch(() => {
                    self.$store.commit("btnLoader", false);
                    // this.$refs.snackbar.show(err, "red");
                });
        },
        deleteImei(imei) {
            var pos = this.newImeis.indexOf(imei);

            if (pos === -1) {
                return;
            }

            this.newImeis.splice(pos, 1);
        },
        addImei() {
             if (this.productName == "") {
                this.imeiNumber = "";
                this.$refs.snackbar.show("Please select product first", "red");
                return;
            }

            if (this.imeiNumber == "") {
                this.$refs.snackbar.show("Please enter IMEI number", "red");
                return;
            }

            // check if imei already exists
            const existing = this.newImeis.find(item => item.imei === this.imeiNumber);
            if (existing) {
                this.imeiNumber = "";
                this.$refs.snackbar.show("This IMEI number already exists", "red");
                return;
            }

            var name = this.productName;

            // add new imei
            this.newImeis.push({
                productName: name,
                imei: this.imeiNumber
            });

            // clear input
            this.imeiNumber = "";
        },
        saveImei() {
            if (this.newImeis.length <= 0) {
                this.$refs.snackbar.show("Please add at least one IMEI", "red");
                return;
            }

            var subscriberId = localStorage.getItem("subscriber_id");

            var imeiStrings = [];
            this.newImeis.forEach(item => {
                imeiStrings.push(item.imei);
            });

            var data = {
                purchaseId: 0,
                purchaseRowId: 0,
                productId: parseInt(this.selectedProductId),
                imeiRecords: imeiStrings,
                StoreId: parseInt(this.activeStore),
                subscriberId: parseInt(subscriberId),
            };

            const url = "/save-device-imeis";
            const self = this;
            this.loader = true;
            this.$store
                .dispatch("post", { url, data })
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.newImeis = [];
                        this.selectedProductId = null;
                        this.productName = "";
                        self.$refs.snackbar.show("IMEI numbers saved successfully", "green");
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        },
        fetchImeis() {
            const self = this;
            var storeId = parseInt(this.activeStore);
            this.loader = true;
            // get record
            this.$store
                .dispatch("get", `/store-device-imeis/${storeId}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.imeiRecords = res.ResponseData.imeiRecords;
                        self.imeiDialog = true;
                        self.loader = false;
                    } else {
                        self.loader = false;
                        this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    self.loader = false;
                    this.$refs.snackbar.show(err, "red");
                });
        }
    },
    created() {

    }
};
</script>

<style lang="scss" scoped>
.genFont {
    font-size: 1.3em;
    font-weight: 500;
}
</style>